
import { useGlobalContext } from "../../context/globalContext";
import BookDemoForm from "./bookDemo";

const DemoPage = (props) => {
    const { setActiveMenu, setErrorMessage, setShowErrorMessage } = useGlobalContext();

    setActiveMenu("#");
    return (
            <>
                <div className="course-container-home container my-5">
                    {/* <div className="row mb-5">
                        <span className="head-text text-center h1 m-10">
                            Choose Your Path to Academic Success
                        </span>
                    </div> */}
                    <div className="row row-cols-1 row-cols-md-3 g-5">
                        <BookDemoForm />
                    </div>
                </div>
            </>
    );
};

export default DemoPage;
